import React from 'react';
import {
  CModal,
} from '@coreui/react';

const Modal = ({ isVisble, children }) => (
  <CModal
    show={isVisble}
    closeOnBackdrop={false}
    centered
  >
    {children}
  </CModal>
);

export default Modal;
